// extracted by mini-css-extract-plugin
export default {"grid":"CardGrid_grid__DQpgt","label":"CardGrid_label__d9slp","value":"CardGrid_value__oDVc6"};